// extracted by mini-css-extract-plugin
module.exports = {"pinTopItem":"styles_pinTopItem__rB_S0","pinBottomItem":"styles_pinBottomItem__1NN9x"};